import WbHttpClient from "../../../services/wbhttpclient";
import React, { useCallback, useState } from "react";
import { useTranslation } from "react-i18next";
import { color as colors, theme, Button } from "@workboard/wobo-ui";
import { createPortal } from "react-dom";
import styled, { createGlobalStyle } from "styled-components";
import { NavLink } from "react-router-dom";
import { v4 as uuid } from "uuid";

const Link = styled(NavLink)``;
const NavBar = styled("nav")``;
const Title = styled("h2")``;

const Styles = createGlobalStyle`
  &&.leftMenuDiv {
      display: none;
  }
  .left-sidebar {
    width: 40px !important;
  }
`;

const id = uuid();

const Sidebar = ({ className, isOpen: initialIsOpen, showOkrsTab: showOkrs }) => {
  const { t } = useTranslation();
  const [isOpen, setState] = useState(initialIsOpen);

  const handleOpen = useCallback(() => {
    setState(state => !state);

    new WbHttpClient().post(`/workboard/saveUserPreferenceWs`, {
      keepOpen: !isOpen
    });
  }, [isOpen, setState]);

  return (
    <aside className={className} data-open={isOpen}>
      <Styles />
      <Button
        onClick={handleOpen}
        isPristine
        aria-expanded={isOpen}
        aria-label="toggle-sidebar"
      >
        <img
          aria-hidden
          src={`/wb/images/icons/main_menu/add/ic-${
            !isOpen ? "show" : "hide"
          }.png`}
        />
      </Button>
      {isOpen && (
        <>
          <Title id={id}>{t("Organization Engagement")}</Title>
          <NavBar aria-describedby={id}>
            <Link to="/index" data-testid="navlink-teams">{t("Teams")}</Link>
            {showOkrs && <Link to="/okrs" data-testid="navlink-okrs">{t("OKRs")}</Link>}
          </NavBar>
        </>
      )}
    </aside>
  );
};

export default styled(props =>
  createPortal(<Sidebar {...props} />, document.getElementById("contentTd"))
)`
  ${Button} {
    height: unset;
    min-width: unset;
    padding: unset;
  }

  padding: 19px 0;
  position: relative;
  width: auto;

  &[data-open="true"] {
    padding: 19px 32px;
    width: 211px;

    ${Button} {
        top: 20px;
        right: 13px;
      }
  }

  ${Button} {
    position: absolute;
    top: 15px;
    right: 6px;
  }

  ${Title} {
    color: ${colors("--black-opacity-84")};
    font-size: 16px;
    font-stretch: normal;
    font-style: normal;
    font-weight: bold;
    letter-spacing: 0.15px;
    line-height: 1.6;
    margin-bottom: 20px;
  } 

  ${NavBar} {
    display: flex;
    flex-direction: column;

    ${Link} {
      ${theme("--font-normal")}
      color: ${colors("--black-opacity-84")};
      margin-bottom: 12px;

      &.active {
        color: ${colors("--blue-500")};
        font-weight: bold;
      }
    }
  }
`;
